import React, { useState } from "react";
import "./TopFreeNavigation1.scss";

interface FlowItem {
  id: number | string;
  name: string;
  url?: string;
  childs?: FlowItem[];
}

interface Props {
  tree: FlowItem[];
  onItemClick?: (item: FlowItem) => void;
}

const TopFreeNavigation1: React.FC<Props> = ({
  tree,
  onItemClick,
}) => {
  const [hoveredMain, setHoveredMain] = useState<number | null>(null);
  const [hoveredChild, setHoveredChild] = useState<string | number | null>(null);
  const [activeMain, setActiveMain] =useState<number | null>(0);
  const [activeChild, setActiveChild] = useState<string | number | null>(null);
  const [activeGrand, setActiveGrand] = useState<string | number | null>(null);
  const [hasInteracted, setHasInteracted] = useState<boolean>(false);

  const handleMainClick = (
    item: FlowItem,
    index: number
  ) => {
    setActiveMain(index);
    setActiveChild(null);
    setActiveGrand(null);
    onItemClick?.(item);
    setHasInteracted(true);
  };

  const handleChildClick = (
    child: FlowItem,
    parentIndex: number
  ) => {
    setActiveMain(parentIndex);
    setActiveChild(child.id);
    setActiveGrand(null);
    onItemClick?.(child);
    setHasInteracted(true);
  };

  const handleGrandClick = (
    grand: FlowItem,
    parentIndex: number,
    childId: string | number
  ) => {
    setActiveMain(parentIndex);
    setActiveChild(childId);
    setActiveGrand(grand.id);
    onItemClick?.(grand);
    setHasInteracted(true);
  };

  return (
    <div className="tpf1-wrapper">
      {tree.map((item, index) => {
        const hasChilds = item.childs && item.childs.length > 0;
        const isActiveMain = activeMain === index;
        return (
          <div
            key={item.id}
            className={`tpf1-step ${ isActiveMain ? "active" : "" }`}
            onClick={(e) => {
              e.preventDefault();
              handleMainClick(
                item,
                index
              )
            }}
          >
            <div
              className="tpf1-hover-zone"
              onMouseEnter={() =>
                setHoveredMain(index)
              }
              onMouseLeave={() => {
                setHoveredMain(null);
                setHoveredChild(null);
              }}
            >
              <div className="tpf1-step-main">
                <div className="tpf1-step-index">
                  {index + 1}.
                </div>

                <div className="tpf1-step-label">
                  {item.name}

                  {isActiveMain && (
                    <span className="tpf1-you-are-here">
                      {hasInteracted ? "You are here" : "Start here"}
                    </span>
                  )}
                </div>
              </div>
              {hasChilds && (
                <div
                  className={`tpf1-underline ${isActiveMain ? "active" : "" }`}
                >
                  <div className="tpf1-underline-line" />
                  <div className="tpf1-underline-arrow">
                    ▾
                  </div>
                </div>
              )}
              {hasChilds &&
                hoveredMain === index && (
                  <div className="tpf1-dropdown">
                    {item.childs!.map(
                      (child) => {
                        const hasGrand = child.childs && child.childs.length > 0;
                        const isActiveChild = activeChild === child.id;
                        return (
                          <div
                            key={child.id}
                            className={`tpf1-dropdown-item tpf1-dropdown-item-main ${ isActiveChild ? "active" : "" }`}
                            onMouseEnter={() =>
                              setHoveredChild(
                                child.id
                              )
                            }
                            onMouseLeave={() =>
                              setHoveredChild(
                                null
                              )
                            }
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              handleChildClick(
                                child,
                                index
                              );
                            }}
                          >
                            {child.name}

                            {hasGrand && (
                              <span className="tpf1-arrow-right">
                                ▶
                              </span>
                            )}

                            {hasGrand &&
                              hoveredChild ===
                                child.id && (
                                <div className="tpf1-dropdown-right">
                                  {child.childs!.map(
                                    (
                                      grand
                                    ) => {
                                      const isActiveGrand = activeGrand === grand.id;
                                      return (
                                        <div
                                          key={
                                            grand.id
                                          }
                                          className={`tpf1-dropdown-item ${
                                            isActiveGrand
                                              ? "active"
                                              : ""
                                          }`}
                                          onClick={(
                                            e
                                          ) => {
                                            e.stopPropagation();
                                            e.preventDefault();
                                            handleGrandClick(
                                              grand,
                                              index,
                                              child.id
                                            );
                                          }}
                                        >
                                          {
                                            grand.name
                                          }
                                        </div>
                                      );
                                    }
                                  )}
                                </div>
                              )}
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default TopFreeNavigation1;
